import * as React from "react";

import primaryColour from "../../constants";

function SvgHarshcornerright(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8821 21.4426L6.58688 14.2265C4.93522 11.4516 6.97472 8.02141 10.1493 8.00007L10.1593 8V8.00003L15.7524 8.00004V5L20.7493 9.47559L15.7524 13.7835V11L10.1653 11C9.23436 11.0091 8.73871 11.9762 9.16477 12.692L14.2578 21.2485C13.5322 21.4159 12.7764 21.5044 12 21.5044C11.6221 21.5044 11.2491 21.4834 10.8821 21.4426Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgHarshcornerright;
